"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useDebounce;
var _react = require("react");
function useDebounce(delay, cb) {
  var handler = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    return function () {
      return clearTimeout(handler.current);
    };
  }, []);
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(handler.current);
    handler.current = setTimeout(function () {
      return cb.apply(void 0, args);
    }, delay);
  };
}